// extracted by mini-css-extract-plugin
export default {"colorBackgroundGrey":"#FBFDFE","smBreak":"600px","breadcrumb":"B0z__HpY9HxAktCyGFYx","hr":"VQoFs_o6Kxdz2r_eMfPG"};